import { render } from "./SustainabilityCircle.vue?vue&type=template&id=4810742d&scoped=true"
import script from "./SustainabilityCircle.vue?vue&type=script&lang=js"
export * from "./SustainabilityCircle.vue?vue&type=script&lang=js"

import "./SustainabilityCircle.vue?vue&type=style&index=0&id=4810742d&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4810742d"]])

export default __exports__